import { openDB } from 'idb'

const objStores = [
  { name: 'CancellationReasons' },
  { name: 'Inspection', key: 'Id', indexes: ['EquipmentCode'] },
  { name: 'InspectionMy', key: 'Id', indexes: ['EquipmentCode'] },
  { name: 'InspectionFav', key: 'Id' },
  { name: 'Model', indexes: ['GroupCode'] },
  { name: 'Type' },
  { name: 'Equipment', key: 'EquipmentId', indexes: ['ModelCode', 'TypeCode'] },
  { name: 'FailureCauses' },
  { name: 'FailureTypes' },
  { name: 'MeasurementUnit' },

  { name: 'EquipmentNode' },
  { name: 'NodeModel' },
  { name: 'ConditionPrameter' },
  { name: 'ParameterLink' },

  { name: 'AllEquipmentInfo', key: 'EquipmentId' },
  { name: 'MyEquipmentInfo', key: 'EquipmentId' },
  { name: 'FavEquipmentInfo', key: 'EquipmentId' },
  { name: 'EquipmentInfo', key: 'EquipmentId' },

  { name: 'WorkRequestDirections' },
  { name: 'WorkRequestCategories' },
  // 'AccessResult',
]

const dbVersion = 9

async function createIndexedDB() {
  if (!('indexedDB' in window)) {
    return null
  }
  try {
    return openDB('eam-inspections', dbVersion, {
      upgrade(db) {
        objStores.map(value => {
          if (db.objectStoreNames.contains(value.name)) {
            db.deleteObjectStore(value.name)
          }
          const objectStore = db.createObjectStore(value.name, {
            keyPath: value.key ? value.key : 'Code'
          })
          if (value.indexes) {
            value.indexes.map(index => objectStore.createIndex(index, index, { unique: false }))
          }
        })
      },
    })
  } catch (error) {
    return null
  }
}

const dbPromise = createIndexedDB()

async function saveDataLocally(objName, items) {
  if (!('indexedDB' in window) || !window.chrome) {
    return null
  }
  try {
    const db = await dbPromise
    const tx = db.transaction(objName, 'readwrite')
    const store = tx.objectStore(objName)
    if (items) {
      if (Array.isArray(items)) {
        for (const item of items) {
          await store.put(item)
        }
        //items.forEach(item => await store.put(item))
        //return Promise.resolve()
        //return Promise.all(items.map(item => store.put(item)))
      } else {
        await store.put(items)
      }
    }
  } catch (e) {
    return null
  }
}

async function clearData(objName) {
  if (!('indexedDB' in window) || !window.chrome) {
    return null
  }
  try {
    const db = await dbPromise
    const tx = db.transaction(objName, 'readwrite')
    const store = tx.objectStore(objName)
    await store.clear()
  } catch (e) {
    return null
  }
}

async function clearLocalDB() {
  if (!('indexedDB' in window) || !window.chrome) {
    return null
  }
  try {
    const db = await dbPromise
    for (var i = db.objectStoreNames.length >>> 0; i--;) {
      const tx = db.transaction(db.objectStoreNames[i], 'readwrite')
      const store = tx.objectStore(db.objectStoreNames[i])
      await store.clear()
    }
  } catch (e) {
    return null
  }
}

async function deleteData(objName, params) {
  if (!('indexedDB' in window) || !window.chrome) {
    return null
  }
  try {
    const db = await dbPromise
    const tx = db.transaction(objName, 'readwrite')
    const store = tx.objectStore(objName)
    if (params) {
      const index = store.index(params.index)
      return index.openCursor(IDBKeyRange.only(params.key))
        .then(function deleteItem(cursor) {
          if (!cursor) {
            return
          }
          cursor.delete()
          return cursor.continue().then(deleteItem)
        })
    }
  } catch (e) {
    return null
  }
}

async function getLocalData(objName, params) {
  if (!('indexedDB' in window) || !window.chrome) {
    return null
  }
  try {
    const db = await dbPromise
    const tx = db.transaction(objName, 'readonly')
    const store = tx.objectStore(objName)
    if (params) {
      const index = store.index(params.index)
      return index.getAll(params.key)
    } else {
      return store.getAll()
    }
  } catch (e) {
    return null
  }
}

async function getLocalDataItem(objName, key) {
  if (!('indexedDB' in window) || !window.chrome) {
    return null
  }
  try {
    const db = await dbPromise
    const tx = db.transaction(objName, 'readonly')
    const store = tx.objectStore(objName)
    if (key) {
      return store.get(key)
    } else {
      return null
    }
  } catch (e) {
    return null
  }
}

export default {
  async getItems(objName, parameters) {
    switch (objName) {
      case 'Equipment':
        if (parameters.modelCode) {
          return getLocalData(objName, {
            index: 'ModelCode',
            key: parameters.modelCode
          })
        }
        if (parameters.typeCode) {
          return getLocalData(objName, {
            index: 'TypeCode',
            key: parameters.typeCode
          })
        }
        return getLocalData(objName)
      case 'Model':
        return getLocalData(objName, {
          index: 'GroupCode',
          key: parameters.groupCode
        })
      case 'Inspection':
      case 'InspectionMy':
        return parameters.equipmentId ? getLocalData(objName, {
          index: 'EquipmentCode',
          key: parameters.equipmentId
        }) : getLocalData(objName)
      case 'FailureCausesAndTypes':
        {
          const causes = await getLocalData('FailureCauses')
          const types = await getLocalData('FailureTypes')
          return new Promise(function (resolve) {
            resolve({
              Causes: causes,
              Types: types
            })
          })
        }
      case 'DirectionsAndCategories':
        {
          const directions = await getLocalData('WorkRequestDirections')
          const categories = await getLocalData('WorkRequestCategories')
          return new Promise(function (resolve) {
            resolve({
              Directions: directions,
              Categories: categories
            })
          })
        }
      case 'AccessResult':
        {
          return new Promise(function (resolve) {
            resolve({
              Types: false,
              Models: false,
              Equipment: false,
              ConditionParameters: false
            })
          })
        }
      case 'EquipmentInfo':
        {
          return getLocalDataItem(objName, parameters.equipmentCode)
        }
      default:
        return getLocalData(objName)
    }
  },
  async saveItems(objName, items, parameters) {

    if (objStores.some(value => value.name == objName)) {
      if (parameters) {
        await this.deleteItems(objName, parameters)
      }
      return saveDataLocally(objName, items)
    } else if (objName == 'FailureCausesAndTypes') {
      if (parameters) {
        await this.deleteItems('FailureCauses', parameters)
        await this.deleteItems('FailureTypes', parameters)
      }
      saveDataLocally('FailureCauses', items.Causes)
      return saveDataLocally('FailureTypes', items.Types)
    } else if (objName == 'DirectionsAndCategories') {
      if (parameters) {
        await this.deleteItems('WorkRequestDirections', parameters)
        await this.deleteItems('WorkRequestCategories', parameters)
      }
      saveDataLocally('WorkRequestDirections', items.Directions)
      return saveDataLocally('WorkRequestCategories', items.Categories)
    } else if (objName == 'InspectionCancel') {
      if (parameters) {
        await this.deleteItems('Inspection', parameters)
      }
      return saveDataLocally('Inspection', items)
    }
  },
  async deleteItems(objName, parameters) {
    switch (objName) {
      case 'Equipment':
        if (parameters.modelCode) {
          return deleteData(objName, {
            index: 'ModelCode',
            key: parameters.modelCode
          })
        }
        if (parameters.typeCode) {
          return deleteData(objName, {
            index: 'TypeCode',
            key: parameters.typeCode
          })
        }
        return deleteData(objName)
      case 'Model':
        return deleteData(objName, {
          index: 'GroupCode',
          key: parameters.groupCode
        })
      case 'Inspection':
      case 'InspectionMy':
        return parameters.equipmentId ? deleteData(objName, {
          index: 'EquipmentCode',
          key: parameters.equipmentId
        }) : clearData(objName)
      case 'FailureCausesAndTypes':
        {
          const causes = await deleteData('FailureCauses')
          const types = await deleteData('FailureTypes')
          return new Promise(function (resolve) {
            resolve({
              Causes: causes,
              Types: types
            })
          })
        }
      case 'DirectionsAndCategories':
        {
          const directions = await deleteData('WorkRequestDirections')
          const categories = await deleteData('WorkRequestCategories')
          return new Promise(function (resolve) {
            resolve({
              Directions: directions,
              Categories: categories
            })
          })
        }
      case 'EquipmentInfo':
        return Promise.resolve()
      default:
        return clearData(objName)
    }
  },
  clearItems(objName) {
    if (objStores.some(value => value.name == objName)) {
      return clearData(objName)
    } else if (objName == 'FailureCausesAndTypes') {
      clearData('FailureCauses')
      return clearData('FailureTypes')
    } else if (objName == 'DirectionsAndCategories') {
      clearData('WorkRequestDirections')
      return clearData('WorkRequestCategories')
    } else if (objName == 'InspectionCancel') {
      return clearData('Inspection')
    }
  },
  async clearDb() {
    await clearLocalDB()
  },
  getUser() {
    return JSON.parse(localStorage.getItem('eamUser'))
  },
  setUser(user) {
    localStorage.setItem('eamUser', JSON.stringify(user))
  },
  getSignInStatus() {
    return localStorage.getItem('signInStatus')
  },
  setSignInStatus(status) {
    localStorage.setItem('signInStatus', status)
  },
  getLastUpdated() {
    return localStorage.getItem('EAMlastUpdated')
  },
  setLastUpdated(date) {
    localStorage.setItem('EAMlastUpdated', date)
  }
}